module.exports = __webpack_public_path__ + "img/_empty_states_contacts.6262af61.svg";